// src/components/TopBar.js
import React from "react";
import { Breadcrumb } from "antd";
import {
  HomeOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import CustomDropdown from "./Dropdown";
import { useUser } from "../context";
import { UserType, Subscription } from "./common";
import { ROUTES } from "./common/constants";
import UserDropdownMenu from "./UserDropdownMenu";
import Calendar from "./Calendar/index";
import { NotificationBell } from "./Notifications/NotificationBell";

const TopBar = () => {
  const { user } = useUser();
  const isTalentPool = user?.subscription?.name === Subscription.TALENT_POOL;

  return (
    <div
      className="topbar"
      style={{
        backgroundColor: "#001529",
        height: "60px",
        display: "flex",
        alignItems: "center",
        padding: "0 20px",
        color: "white",
      }}
    >
      <Breadcrumb style={{ color: "white", lineHeight: "60px" }}>
        <Breadcrumb.Item>
          <Link to="/" style={{ color: "white", fontSize: "20px" }}>
            <HomeOutlined /> Home
          </Link>
        </Breadcrumb.Item>
        {(user?.category === UserType.CANDIDATE || user?.category === UserType.MANAGER) && (
          <Breadcrumb.Item>
            <Link to={ROUTES.CALENDAR} style={{ color: "white", fontSize: "20px" }}>
              <CalendarOutlined /> Calendar
            </Link>
          </Breadcrumb.Item>
        )}
        {user?.category === UserType.CANDIDATE && (
          <Breadcrumb.Item>
            <Link to={ROUTES.INVITATIONS} style={{ color: "white", fontSize: "20px" }}>
              Invitations
            </Link>
          </Breadcrumb.Item>
        )}
        {user?.category === UserType.RECRUITER && (
          <>
            <Breadcrumb.Item>
              <Link to={ROUTES.CANDIDATE_POOL} style={{ color: "white", fontSize: "20px" }}>
                Candidate Pool
              </Link>
            </Breadcrumb.Item>
            {!isTalentPool && (
              <>
                <Breadcrumb.Item>
                  <Link to={ROUTES.JOBS} style={{ color: "white", fontSize: "20px" }}>
                    Jobs
                  </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={ROUTES.REPORTS} style={{ color: "white", fontSize: "20px" }}>
                    Reports
                  </Link>
                </Breadcrumb.Item>
              </>
            )}
            <Breadcrumb.Item>
              <Link to={ROUTES.PAYMENT_HISTORY} style={{ color: "white", fontSize: "20px" }}>
                Billing
              </Link>
            </Breadcrumb.Item>
          </>
        )}
      </Breadcrumb>
      <div style={{ flex: 1 }}></div>
      <NotificationBell />
      <CustomDropdown overlay={<UserDropdownMenu />} />
    </div>
  );
};

export const CalendarWrapper = () => {
  const { user } = useUser();
  const userType = (user?.category === "manager" || user?.category === "recruiter") ? "manager" : "candidate";
  return (
    <Calendar 
      userType={userType}
      userId={undefined}
    />
  );
};

export default TopBar;
